import { useSessionStorage } from '@mantine/hooks';

export function useLeadFormVisibility(
  smartAssistantId?: string,
  defaultValue = true
): [boolean, (val: boolean | ((prevState: boolean) => boolean)) => void] {
  const [showLeadForm, setShowLeadForm] = useSessionStorage({
    key: `showLeadForm-${smartAssistantId}`,
    defaultValue
  });

  return [showLeadForm, setShowLeadForm];
}
